import { all, call } from "redux-saga/effects";
import onLoginStart from "./login";
import onLogOut from "./logOut";

export default function* authSagas() {
  yield all([call(onLoginStart), call(onLogOut)]);
}
